module.exports = __webpack_public_path__ + "static/media/win.bd6ee4c1.ogg";